<section class="main-wrap inner-views">
  <div class="container-wrap">
    <div class="sidebar-container sc-empty">
      <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container address-container prescription-container">
      <div class="row">
        <div class="col-md-12">
          <h1>Welcome to Eyelation</h1>
          <p class="subtitle">Add Prescription</p>
          <p><em>*A prescription will better help us find the right lens for you.*</em></p>
        </div>
        <div class="add-photo-wrap desktop-wrapper">
          <div class="row add-photo">
            <div class="col-md-12">
              <h2>Please upload your prescription in .pdf, .jpeg or .png format.</h2>
              <p>Drag and drop your file below</p>
              <div class="drop-box">
                <span>Directly place file here.</span>
              </div>
            </div>
            <div class="row add-prescription-wrap">
              <p>Or browse and select the file you want to upload</p>
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input #fileInput aria-describedby="inputGroupFileAddon01" class="custom-file-input" id="inputGroupFile01"
                    type="file" (change)="onFileChange($event)">
                  <label class="custom-file-label" for="inputGroupFile01">{{filename}}</label>
                </div>
              </div>
              <div class="col-md-12">
                <div class="formField upload-btn">
                  <input (click)="uploadRx()" id="uploadBtn" type="button" value="Upload">
                </div>
              </div>
              @if (isSubmitted && !isValidFile) {
                <div class="invalid-feedback" [ngClass]="{ 'd-block': isSubmitted && !isValidFile }"
                  >
                  Invalid file, please check that the file is one of these formats: .pdf, .jpeg or .png.
                </div>
              }
              <div class="col-md-12 app-buttons-wrap mt-5">
                <div class="formField submitInput backBack">
                  <input [routerLink]="['../add-photo']" id="backBtn" type="button" value="Back">
                </div>
                <div class="formField submitInput backNext">
                  <input (click)="finish()" [disabled]="!hasRxUploaded" id="nextBtn" type="button"
                    value="Finish">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div #prescriptionMobile class="add-photo-wrap mobile-wrapper row">
          <div class="col btn-wrapper">
            @if (!isPhotoReady) {
              <div>
                <button class="btn btn-block gray-btn" type="button" (click)="fileInput.click()">Browse&hellip;</button>
                <button class="btn-block white-btn" type="button" (click)="cameraPhoto.click()">Take Photo</button>
              </div>
            } @else {
              <button class="btn-block gray-btn" type="button" (click)="cameraPhoto.click()">Upload</button>
              <button class="btn-block white-btn" type="button" (click)="switchPhotoStatus()">Back</button>
            }
            <input #cameraPhoto id="prescriptionUploadFromCamera" (change)="onFileChange($event)" type="file" accept="image/*" style="display: none;">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

